import { env } from './env';
import { defaultTheme, greenTheme, blueTheme, orangeTheme, redTheme, vividOrangeTheme, lightBlueTheme } from '@totalsoft/rocket-ui';

const url = env.REACT_APP_LEASING_API_URL;

export const getDealerLogo = (dealerId, isSmall, token) =>
  `${url}/branding/logo/dealer/${dealerId}?isSmall=${isSmall}&access_token=${token}`;
export const getApplicationLogo = (isSmall, token) => `${url}/branding/logo?isSmall=${isSmall}&access_token=${token}`;

const getTheme = () => {
  switch (env.REACT_APP_THEME) {
    case 'green':
      return greenTheme;
    case 'blue':
      return blueTheme;
    case 'orange':
      return orangeTheme;
    case 'red':
      return redTheme;
    case 'vividOrange':
      return vividOrangeTheme;
    case 'lightBlue':
      return lightBlueTheme;
    default:
      return defaultTheme;
  }
};
export default getTheme;
